export default __webpack_public_path__ + "static/video-installation-72e86d76fa791e08f1623a3ae69d062f.jpg";